import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ['titleInput', 'durationInput', 'scheduledAtInput', 'endDateInput', 'hourInput', 'minuteInput'];
  static values = {
    prestationsMap: Object,
    property: String,
  }

  connect() {
    this.updateHourAndMinuteFromDuration();
    this.updateEndDate();
  }

  updateInterTitle(e) {
    const prestaVal = e.currentTarget['form--collection-select--component'].value;
    if (!this.prestationsMapValue[prestaVal])
        return;

    const prestaName = this.prestationsMapValue[prestaVal].name;
    const prestaDuration = this.prestationsMapValue[prestaVal].duration;
    let title = `Intervention CM - ${prestaName}`
    if (this.propertyValue != null && this.propertyValue.length > 0)
      title += ` - ${this.propertyValue}`
    this.titleInputTarget.value = title;
    this.durationInputTarget.value = prestaDuration;
    this.durationInputTarget.dispatchEvent(new Event('change'))
    this.durationInputTarget.dispatchEvent(new Event('input'))
  }

  updateEndDate() {
    if (!this.durationInputTarget.value || typeof(this.durationInputTarget.value) == 'undefined') {
      this.endDateInputTarget.textContent = "dd / mm / yyyy, --:--";
      return
    }

    const startDate = new Date(this.scheduledAtInputTarget.value);
    const durationInMinutes = parseInt(this.durationInputTarget.value, 10);

    if (isNaN(startDate.getTime()) || isNaN(durationInMinutes)) {
      this.endDateInputTarget.textContent = "dd / mm / yyyy, --:--";
      return;
    }

    const endDate = new Date(startDate.getTime());
    endDate.setMinutes(endDate.getMinutes() + durationInMinutes);

    const pad = (n) => n.toString().padStart(2, '0');
    const formatted = `${pad(endDate.getDate())} / ${pad(endDate.getMonth() + 1)} / ${endDate.getFullYear()}, ${pad(endDate.getHours())}:${pad(endDate.getMinutes())}`;

    this.endDateInputTarget.textContent = formatted;
  }

  updateDurationFromHourOrMinute() {
    const hour = parseInt(this.hourInputTarget.value, 10) || 0;
    const minute = parseInt(this.minuteInputTarget.value, 10) || 0;
    const total = hour * 60 + minute;
    this.durationInputTarget.value = total;
    this.durationInputTarget.dispatchEvent(new Event('input'));
    this.durationInputTarget.dispatchEvent(new Event('change'));
  }

  updateHourAndMinuteFromDuration() {
    const duration = parseInt(this.durationInputTarget.value, 10) || 0;
    const hour = Math.floor(duration / 60);
    const minute = duration % 60;
    this.hourInputTarget.value = hour;
    this.minuteInputTarget.value = minute;
  }
}
